/**
 * Why the history stops where it does (docs/refactor/28): the plan's days — 3 on Free, 90 on Pro, 365 on Team — for
 * sessions, prompts, costs and reports. Said once, plainly, with the way to see more; nothing is deleted by it.
 */

import { Link } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { api } from '../lib/api'
import { useI18n } from '../lib/i18n'

export function HistoryLimitNote() {
  const { t } = useI18n()
  const { data: me } = useQuery({ queryKey: ['me'], queryFn: api.auth.me, staleTime: 5 * 60_000 })
  const days = me?.memoryDays
  if (!days || days >= 365) return null
  return (
    <p className="tiny muted" style={{ margin: 0 }}>
      {t('history.limit', { days })} <Link to="/settings/billing">{t('history.more')}</Link>
    </p>
  )
}
